export const DEFAULT_FEE_SPLIT = {
  seller: 0.9,
  creatorFee: 0.05,
};

export const DEFAULT_OVERPRICE = 0.03;

export const DEFAULT_FEE_ON_CREATION = 0.02;
